export enum HrRoleId {
  ADMIN_STD = 'rl::a::hr-admin-std',
  ADMIN_CMPL = 'rl::a::hr-admin-cmpl',
  MANAGER_STD = 'rl::hr-manager-std',
  MANAGER_CMPL = 'rl::hr-manager-cmpl',
  VIEWER_STD = 'rl::hr-viewer-std',
  VIEWER_CMPL = 'rl::hr-viewer-cmpl',
}

export enum HrRoleArchetype {
  ADMIN = 'admin',
  MANAGER = 'manager',
  VIEWER = 'viewer',
}

export enum HrRoleTier {
  STD = 'std',
  CMPL = 'cmpl',
}

export enum HrPermissionSetId {
  EMPLOYEE_VIEW = 'ps::hr-employee-view',
  EMPLOYEE_MANAGE = 'ps::hr-employee-manage',
  EMPLOYEE_INVITE = 'ps::hr-employee-invite',
  EMPLOYEE_DISABLE = 'ps::hr-employee-disable',
  EMPLOYEE_EXPORT = 'ps::hr-employee-export',
  FLEX_CREDITS_MANAGE = 'ps::hr-flex-credits-manage',
  FLEX_CREDITS_VIEW = 'ps::hr-flex-credits-view',
  FLEX_CREDITS_EXPORT = 'ps::hr-flex-credits-export',
  FRINGE_THRESHOLDS_MANAGE = 'ps::hr-fringe-thresholds-manage',
  FRINGE_THRESHOLDS_VIEW = 'ps::hr-fringe-thresholds-view',
  CARD_ORDERS_VIEW = 'ps::hr-card-orders-view',
  CARD_ORDER = 'ps::hr-card-order',
  CARD_REPLACE = 'ps::hr-card-replace',
  FRINGE_ASSIGNMENTS_VIEW = 'ps::hr-fringe-assignments-view',
  FRINGE_ASSIGNMENTS_CREATE = 'ps::hr-fringe-assignments-create',
  FRINGE_ASSIGNMENTS_EXPORT = 'ps::hr-fringe-assignments-export',
  OFFICES_VIEW = 'ps::hr-offices-view',
  OFFICES_MANAGE = 'ps::hr-offices-manage',
  DASHBOARD_VIEW = 'ps::hr-dashboard-view',
  DASHBOARD_EXPORT = 'ps::hr-dashboard-export',
  HR_USERS_VIEW = 'ps::hr-users-view',
  HR_USERS_MANAGE = 'ps::hr-users-manage',
  HR_BASE_CREATE = 'ps::hr-base-create',
  ROLES_VIEW = 'ps::hr-roles-view',
  ROLES_MANAGE = 'ps::hr-roles-manage',
  REPORT_TRACCIATI_VIEW = 'ps::hr-report-tracciati-view',
  REPORT_TRACCIATI_EXPORT = 'ps::hr-report-tracciati-export',
  PAYMENTS_VIEW = 'ps::hr-payments-view',
  PAYMENTS_MANAGE = 'ps::hr-payments-manage',
  REPORT_FLEX_BENEFITS_VIEW = 'ps::hr-report-flex-benefits-view',
  REPORT_FLEX_BENEFITS_EXPORT = 'ps::hr-report-flex-benefits-export',
}

export enum HrPermission {
  EMPLOYEES = 'hr.employees',
  FLEX_CREDITS = 'hr.flex-credits',
  FRINGE_THRESHOLDS = 'hr.fringe-thresholds',
  CARDS = 'hr.cards',
  FRINGE_ASSIGNMENTS = 'hr.fringe-assignments',
  OFFICES = 'hr.offices',
  DASHBOARD = 'hr.dashboard',
  USERS = 'hr.users',
  PAYMENTS = 'hr.payments',
  REPORTS_TRACCIATI = 'hr.reports.tracciati',
  REPORTS_FLEX_BENEFITS = 'hr.reports.flex-benefits',
  ROLES = 'hr.roles',
  BASE = 'hr.base',
}
